// 周扣款起始日枚举 1-7表示周一到周日
export const startDateState = {
  1: '周一',
  2: '周二',
  3: '周三',
  4: '周四',
  5: '周五',
  6: '周六',
  7: '周日',
}
